import React from 'react';
import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IListConfigSwitchColumn} from '@src/@interfaces/components/List/IListConfigSwitchColumn';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';

export default class SwitchColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn<IListConfigSwitchColumn>, Model> {
    protected get value(): any {
        return super.value ?
                <i className="fa-solid fa-check"/> :
                <i className="fa-solid fa-xmark"/>;
    }
}
